import { ReactComponent as RefreshIcon } from 'assets/icons/refresh-icon.svg';
import { StyledRefreshButton } from './styles';
import { useTranslation } from 'react-i18next';
interface IDataExportButtonProps {
  children?: React.ReactNode;
  onClick: () => void;
}
export const RefreshButton = ({ children, onClick }: IDataExportButtonProps) => {
  const { t } = useTranslation();
  return (
    <StyledRefreshButton onClick={onClick}>
      <RefreshIcon className="button-icon" />
      <span className="title">{t('adminPage.refresh')}</span>
    </StyledRefreshButton>
  );
};
